import { useRouter } from 'next/router';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

interface ChildProps {
  displayNew?: boolean;
  icon: ReactNode;
  label: string;
  clickHandler: () => void;
  dataTest?: string;
}

const EntityDetail = ({
  displayNew,
  icon,
  label,
  clickHandler,
  dataTest
}: ChildProps): JSX.Element => {
  const { locale } = useRouter();
  return (
    <DetailItem onClick={clickHandler} locale={locale} data-test={dataTest}>
      {icon}
      <span className={`text-2 ${displayNew ? 'new-text' : ''}`}>{label}</span>
    </DetailItem>
  );
};

const DetailItem = styled.div<any>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 132px;
  min-width: 100px;
  height: 80px;
  border: 1px solid #e4ebf2;
  border-radius: ${props => props.theme.borderRadius};
  cursor: pointer;
  transition: all 0.2s ease-out;
  position: relative;
  gap: 6px;
  padding: 10.959px 13.151px;
  border: 0.548px solid var(--Secondary-Blue-blue-50, #e6eff5);
  background: #f7f9fd;
  box-shadow: 0 0 4.384px 1.096px rgba(184, 184, 184, 0.2);

  @media (max-width: ${props => props.theme.breakPoints.mobile.max}) {
    gap: 16px;
  flex: 1;
  max-width: unset;

    svg{
      width: 28px;
      height: 28px;
      min-width: 28px;
      min-height: 28px;
    }
  }

  span {
    font-size: 16px;
    color: ${props => props.theme.light.colors.black};
    font-family: materialMedium;
    white-space: nowrap;

    @media (max-width: ${props => props.theme.breakPoints.mobile.max}) {
      font-size: 14px;
    }

    &.new-text {
      position: relative;
      &::after {
        content: ${props => (props.locale === 'ar' ? '"جديد"' : '"New"')};
        position: absolute;
        top: -55px;
        display: flex;
        justify-content: center;
        align-items: center;
        right: ${props => (props.locale == 'en' ? '-20px' : '-10px')};
        color: ${props => props.theme.light.colors.white};
        background-color: ${props => props.theme.light.colors.primaryOrange};
        width: 38px;
        height: 18px;
        border-radius: 175px;
        color: #fff;
        text-align: center;
        font-family: materialLight;
        font-size: 12px;
        text-transform: capitalize;
      }
    }
  }
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      border: 1px solid ${props => props.theme.light.colors.tertiary};
    }
  }
`;
export default EntityDetail;
